import { registerPlugin } from '@capacitor/core';
const capLocation = registerPlugin('capLocation', {
    web: () => import('./web').then(m => new m.capLocationWeb()),
});
export * from './definitions';
export { capLocation };
//# sourceMappingURL=index.js.map